

(function() {
    const format = document.querySelector('[data-menu-format]');

    if(format == null)
        return;

    const data = JSON.parse(format.innerHTML);

    for(const item of data) {
        const spans = document.querySelectorAll('.page-header .navtext, .page-header .sliderow__title');

        spans.forEach(span => {
            if(item.names.includes(span.innerHTML)) {
                if(item.italic) {
                    span.style.fontStyle = 'italic';
                } 
                
                if(item.color) {
                    span.style.color = item.color;
                } 

                if(item.badge) {
                    span.style.float = 'left';
                    span.style.marginRight = '10px';
                    span.style.width = 'fit-content';

                    let weight = 400;
                    if(item.bold) {
                        weight = 800;
                    } 

                    let badge_color = '';
                    if(item.badge_color) {
                        badge_color = `style="color: ${item.badge_color};font-weight: ${weight};"`;
                    }
                    
                    span.parentElement.innerHTML += `<span class="theme__header__badge" ${badge_color}>${item.badge}</span>`;
                }
            }
        });
    }
})();